import { IInvoiceTagsResponse } from 'shared';

import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';

export const invoiceTagsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchInvoiceTags: builder.query<IInvoiceTagsResponse, { organisationId: string }>({
      query: ({ organisationId }) => ({
        url: `invoice-tags`,
        method: `GET`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      providesTags: result => result?.tags.map(t => ({
        id: t.name,
        type: CacheTags.InvoiceTags,
      })),
    }),
    createInvoiceTag: builder.mutation<void, { organisationId: string; tagName: string; selectedInvoices: string[]; color?: string | null }>({
      query: ({ organisationId, tagName, selectedInvoices, color }) => ({
        url: `invoice-tags`,
        method: `PUT`,
        data: {
          tagName,
          selectedInvoices,
          color,
        },
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      invalidatesTags: () => [{ type: CacheTags.InvoiceTags }, { type: CacheTags.Invoices }],
    }),
    updateInvoiceTag: builder.mutation<void, { organisationId: string; tagName: string; color: string | null }>({
      query: ({ organisationId, tagName, color }) => ({
        url: `invoice-tags/${encodeURIComponent(tagName)}`,
        method: `PATCH`,
        data: {
          color,
        },
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      invalidatesTags: () => [{ type: CacheTags.InvoiceTags }],
    }),
    deleteInvoiceTag: builder.mutation<void, { organisationId: string; tagName: string }>({
      query: ({ organisationId, tagName }) => ({
        url: `invoice-tags/${encodeURIComponent(tagName)}`,
        method: `DELETE`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      invalidatesTags: () => [{ type: CacheTags.InvoiceTags }, { type: CacheTags.Invoices }],
    }),
    applyInvoiceTag: builder.mutation<void, { organisationId: string; invoiceIds: string[]; tag: string }>({
      query: ({ organisationId, invoiceIds, tag }) => ({
        url: `invoice/tags`,
        method: `POST`,
        data: {
          invoiceIds,
          tag,
        },
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      invalidatesTags: (result, error, { invoiceIds }) => invoiceIds.map(id => ({ type: CacheTags.Invoices, id })),
    }),
    clearInvoiceTags: builder.mutation<void, { organisationId: string; invoiceIds: string[]; tagName?: string }>({
      query: ({ organisationId, invoiceIds, tagName }) => ({
        url: `invoice/tags`,
        method: `DELETE`,
        data: {
          invoiceIds,
          tagName,
        },
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      invalidatesTags: (result, error, { invoiceIds }) => invoiceIds.map(id => ({ type: CacheTags.Invoices, id })),
    }),
  }),
});

export const {
  useFetchInvoiceTagsQuery,
  useCreateInvoiceTagMutation,
  useUpdateInvoiceTagMutation,
  useDeleteInvoiceTagMutation,
  useApplyInvoiceTagMutation,
  useClearInvoiceTagsMutation,
} = invoiceTagsApi;
